import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Workspace from '../views/Workspace.vue'
import Financial from '../views/Financial.vue'
import HR from '../views/HR.vue'
import Contact from '@/views/Contact.vue'
import AgileView from '../views/AgileView.vue'
import KanbanBoardView from '../views/KanbanBoardView.vue'
import EmailView from '../views/EmailView.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import TermsOfService from '../views/TermsOfService.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/workspace',
    name: 'Workspace',
    component: Workspace
  },
  {
    path: '/agile',
    name: 'Agile',
    component: AgileView
  },
  {
    path: '/email',
    name: 'Email',
    component: EmailView
  },
  {
    path: '/financial',
    name: 'Financial',
    component: Financial
  },
  {
    path: '/hr',
    name: 'HR',
    component: HR
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('../views/Projects.vue')
  },
  {
    path: '/manufacturing',
    name: 'manufacturing',
    component: () => import('../views/Manufacturing.vue')
  },
  {
    path: '/crm',
    name: 'crm',
    component: () => import('../views/CRM.vue')
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/Support.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/kanban-board',
    name: 'KanbanBoard',
    component: KanbanBoardView
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPolicy
  },
  {
    path: '/terms',
    name: 'Terms',
    component: TermsOfService
  },
  {
    path: '/sales',
    name: 'Sales',
    component: () => import('../views/Sales.vue')
  },
  {
    path: '/demo',
    redirect: '/'
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router 